import { SETONBOARDING } from '../action-types/onboardingActionTypes'

export const setOnboarding = (value) => ({
	type: SETONBOARDING,
	payload: value
})
